"use strict";
var ACC;
ACC.carousel = {
	_autoload: [
		"bindCarousel",
		"loveListStaticButton",
	],

	bindCarousel: function(){

		// Home / Hero Carousel

		// Get Carousel Speed if set
		var carouselSpeed = $(".carouselSpeed").val();

		if ((carouselSpeed === null) || (carouselSpeed === undefined)) {
			carouselSpeed = 5000;
		}

		// Set up Carousel
		var slider = $('.hero-single');
		slider.slick({
			speed: 600,
			infinite: true,
			autoplay: true,
			autoplaySpeed: carouselSpeed,
			dots: true,
			accessibility: false,
			responsive: [
				{
					breakpoint: 980,
					settings: {
						arrows: false
					}
				},
				{
					breakpoint: 640,
					settings: {
						arrows: false
					}
				},
				{
					breakpoint: 480,
					settings: {
						arrows: false
					}
				},
				{
					breakpoint: 320,
					settings: {
						arrows: false
					}
				},
				{
					breakpoint: 0,
					settings: {
						arrows: false
					}
				}
			]
		});
		$(".hero-single .slick-track").each(function(index, elm) {
			$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.bg-img, div[aria-hidden="true"] .linkButtons ul li a')).attr('tabindex', -1);
			$($(elm).find('div[aria-hidden="false"] a.bg-img, div[aria-hidden="false"] .linkButtons ul li a')).attr('tabindex', 0);
		});
		$('.hero-single .slick-arrow, .hero-single .slick-dots li').click(function(){
			$(".hero-single .slick-track").each(function(index, elm) {
				$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.bg-img, div[aria-hidden="true"] .linkButtons ul li a')).attr('tabindex', -1);
				$($(elm).find('div[aria-hidden="false"] a.bg-img, div[aria-hidden="false"] .linkButtons ul li a')).attr('tabindex', 0);
			});
		});

		// Because it was originally called here, a call remains
		// to avoid breaking anything. However, changes mean that
		// this needs to be called again after an AJAX request
		// in acc.carousel.js, targeting #solrCarousel, means we
		// have put in a callable function to be run on success of
		// that request.
		this.setupProductCarousel();

		// GTM hero content carousel related
		$(".slick-arrow").on("click", function() {
			ACC.carousel.gtmContentCarouselClicked($(this));
		});

		$(".slick-dots li").on("click", function() {
			ACC.carousel.gtmContentCarouselClicked($(this));
		});

		$(".slick-slide .linkButtons li").on("click", function() {
			ACC.carousel.gtmContentCarouselCTAClicked($(this));
		});

		$(".category-carousel-link-item").on("click", function() {
            ACC.carousel.gtmCategoryCarouselClicked($(this));
		});

		/* Quickfix: iPhone5 (and below) have issues with moving carousel appearing to close
			an open mobile menu. Adding these event listeners to compensate by toggling actions */
  		$(document).on("ACC.sidepanel.beforeopen", function() {
			var $slickSlider = $(".slick-slider");
			if($slickSlider.length) {
  				$slickSlider.slick("pause");
			}
  		});

  		$(document).on("ACC.sidepanel.afterclose", function() {
			var $slickSlider = $(".slick-slider");

			if($slickSlider.length) {
  				$slickSlider.slick("play");
			}

  		});

		// GTM product carousel - on thumbnail click
		$('.selectors').on('click', '.mz-thumb', function() {
			ACC.carousel.gtmProductCarouselClicked($(this));
		});

		// Accessibility handler - on next arrow
		$('.mz-nav-controls').on('keydown', '.mz-button-next', function(event) {
			if (ACC.carousel.magicZoomKeydown(event)) {
				MagicZoom.next('zoom')
			}
		});

		// Accessibility handler - on prev arrow
		$('.mz-nav-controls').on('keydown', '.mz-button-prev', function(event) {
			if (ACC.carousel.magicZoomKeydown(event)) {
				MagicZoom.prev('zoom')
			}
		});

		// Accessibility handler - on main image keydown
		$('.gallery-carousel').on('keydown', '.MagicZoom', function(event) {
			if (ACC.carousel.magicZoomKeydown(event)) {
				MagicZoom.expand('zoom')
			}
		});

		// Accessibility handler - on thumbnail
		$('.selectors').on('keydown', '.mz-thumb', function(event) {
			if (ACC.carousel.magicZoomKeydown(event)) {

				var magicZoomSelectors = document.querySelectorAll('#magicZoomSelectors .mz-thumb');

				$(magicZoomSelectors).each( function() {
					if ($(this).hasClass('mz-thumb-selected')) {
						$(this).attr("class", "mz-thumb");
					};
				});

				var newThumbnail = document.activeElement
				newThumbnail.setAttribute("class", "mz-thumb mz-thumb-selected");

				$(magicZoomSelectors).each( function() {
					if ($(this).hasClass('mz-thumb-selected')) {
						var index = $(this).index();
						var viewNumber = index;
						MagicZoom.switchTo('zoom', viewNumber)
					};
				});
			}
		});

		// GTM product carousel - on button click
		$('.pdp-carousel__inner').on('click', '.mz-nav-controls .mz-button', function() {
			var magicZoomSelectors = document.querySelectorAll('#magicZoomSelectors .mz-thumb');
			var mzSelectorsLength = magicZoomSelectors.length;

			$(magicZoomSelectors).each( function() {
				if ($(this).hasClass('mz-thumb-selected')) {
					var index = $(this).index() + 1;
					var productCode = $(this).data('productcode');
					var viewNumber = index + "/" + mzSelectorsLength;
					ACC.gtm.trackProductGalleryImagesClickGtmEvent('' + productCode + '', '' + viewNumber + '');
				};
			});

		});

		// Observe for added elements - ZoomMagic added mz-expand
		$(document).ready(function() {
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.addedNodes && mutation.addedNodes.length > 0) {
						var hasClass = [].some.call(mutation.addedNodes, function(el) {
							if( el.classList ) {
								return el.classList.contains('mz-expand');
							} else {
								return false;
							}
						});
						if (hasClass) {
							$('.mz-expand .mz-nav-controls .mz-button-next, .mz-expand .mz-nav-controls .mz-button-prev').click(function() {
								var magicZoomSelectors = document.querySelectorAll('.magic-thumbs-wrapper > ul > .magic-thumb');
								var mzSelectorsLength = magicZoomSelectors.length;
								$(magicZoomSelectors).each( function() {
									if ($(this).hasClass('magic-thumb-selected')) {
										var index = $(this).index() + 1;
										var productCode = document.getElementsByName("productCodePost")[0].value.slice(0, -5);
										var viewNumber = index + "/" + mzSelectorsLength;
										ACC.gtm.trackProductGalleryImagesClickGtmEvent('' + productCode + '', '' + viewNumber + '');
									};
								});
							});
							observer.disconnect();
						};
					};
				});
			});

			var config = {
				childList: true
			};

			if(document.querySelector('.page-productDetails') !== null ){
				observer.observe(document.querySelector('.page-productDetails'), config);
			}

		});

	},

	moveFocusToItem: function(direction, slickSlides) {
		let targetItem;

		if (direction === 'next') {
			// Move focus to the last visible item
			targetItem = Array.from(slickSlides)
				.filter(item => item.getAttribute('aria-hidden') !== 'true')
				.pop();
		} else if (direction === 'prev') {
			// Move focus to the first visible item
			targetItem = Array.from(slickSlides)
				.filter(item => item.getAttribute('aria-hidden') !== 'true')
				.shift();
		}

		if (targetItem) {
			const targetItemBox = targetItem.querySelector('.category-carousel-link-item-box a');
			if (targetItemBox) {
				targetItemBox.focus();
			}
		}
	},

	handleArrowKeydown: function(e, slickSlides) {
		if (e.key === 'Enter' || e.key === 'Tab') {
			// Delay to ensure aria-disabled is updated
			setTimeout(() => {
				const arrowDom = e.currentTarget;
				const arrowDisabled = arrowDom.getAttribute('aria-disabled');

				const directionArrow = arrowDom.classList.contains('slick-next') ? 'next' : 'prev';

				if (arrowDisabled === 'true') {
					ACC.carousel.moveFocusToItem(directionArrow, slickSlides);
				}
			}, 300);
		}
	},

	alignCategoryHeights: function(title, content) {
		if(title.length > 0) {
			title.css('height', 'auto');
			ACC.global.alignHeights(title);
		}
		if(content.length > 0) {
			content.css('height', 'auto');
			ACC.global.alignHeights(content);
		}
	},

	changeSlickSliderBehavior: function(slickItems) {
		setTimeout(() => {
			slickItems.each(function() {
				$(this).removeAttr('tabindex');
			});
		}, 500);
	},

	removeTabindexOnClick: function(slickItems, slickArrows) {
		slickArrows.each(function() {
			$(this).on('click', function() {
				ACC.carousel.changeSlickSliderBehavior(slickItems);
			});
		});
	},

	initializeCarousel: function($carouselContainer) {
		$carouselContainer.each(function() {
			const $categoryContainerTitle = $(this).find('.category-carousel-link-item-details h3');
			const $categoryContainerContent = $(this).find('.category-carousel-link-item-details .link-description');

			const slickSlides = $(this).find('.slick-slide');
			const prevArrow = $(this).find('.slick-prev');
			const nextArrow = $(this).find('.slick-next');
			const slickSliderArrows = $(this).find('.slick-arrow');

			if(slickSlides.length) {
				ACC.carousel.changeSlickSliderBehavior(slickSlides);
			}
			if(slickSlides.length && slickSliderArrows.length) {
				ACC.carousel.removeTabindexOnClick(slickSlides, slickSliderArrows);
			}
			if (prevArrow.length) {
				prevArrow.on('keydown', function(e) {
					ACC.carousel.handleArrowKeydown(e, slickSlides);
				});
			}
			if (nextArrow.length) {
				nextArrow.on('keydown', function(e) {
					ACC.carousel.handleArrowKeydown(e, slickSlides);
				});
			}

			// Align heights on initialization
			ACC.carousel.alignCategoryHeights($categoryContainerTitle, $categoryContainerContent);

			// Align heights on window load
			$(window).on('load', function() {
				ACC.carousel.alignCategoryHeights($categoryContainerTitle, $categoryContainerContent);
			});

			// Align heights on window resize
			$(window).on('resize', function() {
				ACC.carousel.alignCategoryHeights($categoryContainerTitle, $categoryContainerContent);
			});
		});
	},

	onFocusOnMobile: function(linkItem, item) {
		linkItem.each(function() {
			$(this).on('focus', function() {
				this.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
			});
		});

		item.removeAttr('aria-hidden');
	},

	centerAlignCarouselItems: function(centerAlignCarouselComponent) {
		centerAlignCarouselComponent.on('init', function(event, slick) {
			// Access the current settings of the slick slider
			const slidesToShow = slick.options.slidesToShow;
			const slickSlideCount = slick.slideCount;
			const parentCarouselItem = $(this).closest('.component-grid-item');

			if(slickSlideCount != null) {
				if (slickSlideCount <= slidesToShow) {
					parentCarouselItem.addClass('center-carousel-items');
				} else {
					parentCarouselItem.removeClass('center-carousel-items');
				}
			}
		});
	},
	isShyBrandPage: function(){
		const url = window.location.href;
		const parsedUrl = new URL(url);
		return parsedUrl.pathname.includes('/brands')
	},

	gtmCategoryCarouselClicked: function($component) {
		if ($component != null) {
			const viewNumber = $component.data("viewnumber");
      		const componentId = $component.closest(".category-carousel-main").data("componentid");

			if (componentId.length != null && viewNumber != null) {
				ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
	        }
	    }
    },

	setAltTextForDeviceType: function(desktopAlt, tabletAlt, mobileAlt, id) {
		const altText = ACC.common.chooseResizeVal(desktopAlt, tabletAlt, mobileAlt);
		const imageId = `img_${id}`;
        document.getElementById(imageId).alt = altText;
	},

	setupCtalinksCarousel: function() {
		$(document).ready(function() {
			$('.carousel .ctaLinks').each(function() {
				const $ctaLinks = $(this);
				const $carousel = $ctaLinks.closest('.carousel');
				const $prev = $carousel.find('.slick-prev');
				const $next = $carousel.find('.slick-next');
	
				$ctaLinks.css({
					'overflow-x': 'auto',
					'overflow-y': 'visible',
					'white-space': 'nowrap',
					'scroll-behavior': 'smooth'
				});
	
				const scrollAmount = 400;
	
				$prev.on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					$ctaLinks[0].scrollLeft -= scrollAmount;
				});
	
				$next.on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					$ctaLinks[0].scrollLeft += scrollAmount;
				});
	
				function toggleArrows() {
					if ($ctaLinks[0].scrollWidth > $ctaLinks[0].clientWidth + 1) {
						$prev.show();
						$next.show();
						$ctaLinks.css('justify-content', 'flex-start');
					} else {
						$prev.hide();
						$next.hide();
						$ctaLinks.css('justify-content', 'center');
					}
				}
				toggleArrows();
				$(window).on('resize', toggleArrows);
	
				const $links = $ctaLinks.find('li a');
				$links.on('focus', function() {
					const $li = $(this).closest('li');
					const isLast = $li.is(':last-child');

					// scroll so the last link is fully visible
					if (isLast) {
						const container = $ctaLinks[0];
						const lastLi = $li[0];
						const lastLiRight = lastLi.offsetLeft + lastLi.offsetWidth;
						const maxScroll = lastLiRight - container.clientWidth;
						container.scrollLeft = maxScroll > 0 ? maxScroll : 0;
					}
				});
				
				// removing border for cta links if the PLP banner has background colour
				const $bannerBg = $carousel.closest('.isWithBackground').find('.background-element');
				if ($bannerBg.length) {
					let bgColour = $bannerBg.css('background-color');
					if (
						bgColour &&
						bgColour !== 'rgb(255, 255, 255)' &&
						bgColour !== 'transparent' &&
						bgColour !== 'rgba(0, 0, 0, 0)'
					) {
						$ctaLinks.find('li a').addClass('no-border');
					}
				}
			});
		});
	},

	setupCategoryCarousel: function() {
		const $containerCategoryCarousel = $('.component-grid-item');
		const componentIds = [];

		if ($containerCategoryCarousel.length > 0) {
			$containerCategoryCarousel.each(function() {
				componentIds.push($(this).data('componentId'));
			});

			if (componentIds.length > 0) {

				componentIds.forEach(function(componentId) {
					const targetSliderCategory = componentId ? ('#categoryCarousel-' + componentId + ' ') : '';
					const $carouselContainer = $(targetSliderCategory + '.category-carousel-link-items');
					const $categoryCarousel = $('.category-carousel-main');
					const $categoryCarouselItem = $(targetSliderCategory + '.category-carousel-link-item');
					const $categoryCarouselItemLink = $(targetSliderCategory + '.category-carousel-link-item .category-carousel-links');
					const roundCarousel = $(targetSliderCategory + '.categoryCarouselItems_ROUND');

					$(window).on('load', function() {
						if ($(window).width() < 600) {
							ACC.carousel.onFocusOnMobile($categoryCarouselItemLink, $categoryCarouselItem);
						}
					});

					$(window).on('resize', function() {
						if ($(window).width() < 600) {
							ACC.carousel.onFocusOnMobile($categoryCarouselItemLink, $categoryCarouselItem);
						}
					});

					[...$categoryCarousel].forEach(carousel => {
						$(carousel).css('visibility', 'visible')
					});

					$(document).ready(function() {
						ACC.carousel.initializeCarousel($carouselContainer);
					});

                    if (typeof roundCarousel !== 'undefined' && roundCarousel !== null && roundCarousel.length > 0) {
                        // Add the slick slider for round-image carousels on desktop screen sizes
                        if ($(window).width() > 1023) {
                            ACC.carousel.observeElementWidthWithIntersection(roundCarousel[0], function(){
                                if ($(window).width() > 600) {
                                    ACC.carousel.centerAlignCarouselItems(roundCarousel);
                                }

                                const isWideContainer = roundCarousel.closest('.wide-container');
                                const totalItems = roundCarousel.find('.category-carousel-link-item').length;

                                const additionalBreakpointsForWiderContainer = isWideContainer.length ? [{
                                    breakpoint: 1280,
                                    settings: {
                                        slidesToShow: totalItems <= 10 ? totalItems : 10,
                                        slidesToScroll: 1,
                                        infinite: false,
                                        dots: false,
                                        arrows: true,
                                    }
                                }] : [{}];
                                roundCarousel.slick({
                                    infinite: false,
                                    speed: 300,
                                    slidesToShow: totalItems <= 10 ? totalItems : (isWideContainer.length ? 11 : 10),
                                    slidesToScroll: 1,
                                    arrows: true,
                                    dots: false,
                                    variableWidth: false,
                                    centerMode: false,
                                    accessibility: true,
                                    responsive: [
                                        ...additionalBreakpointsForWiderContainer,
                                        {
                                            breakpoint: 1024,
                                            settings: {
                                                slidesToShow: totalItems < 8 ? totalItems : 8.5,
                                                slidesToScroll: 5,
                                                infinite: false,
                                                dots: false,
                                                arrows: true,
                                            }
                                        }
                                    ]
                                });
                                $(roundCarousel).on('swipe', function(event, slick, direction) {
                                    const $slickTrack = $(this).find('.slick-track');
                                    const currentSlide = slick.currentSlide;
                                    if (currentSlide === 0 && direction === 'right') {
                                      // Swiping back to the first element
                                      $slickTrack.css('margin-left', '15px');
                                    } else {
                                      $slickTrack.css('margin-left', '0');
                                    }
                                });
                            })

                        }
                        else {
                            // Remove the slick slider for round-image carousels on tablet and mobile screen sizes
                            if ($(roundCarousel).hasClass('slick-initialized')) {
                                roundCarousel.slick("unslick");
                            }
                        }
                    }

					const squareCarousel = $(targetSliderCategory + '.categoryCarouselItems_SQUARE');
                    if (typeof squareCarousel !== undefined && squareCarousel !== null && squareCarousel.length > 0) {
                        // Add the slick slider for square-image carousels on desktop screen sizes
                        if ($(window).width() > 1023) {
                            squareCarousel.slick({
                                infinite: false,
                                speed: 300,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                arrows: true,
                                dots: false,
                                centerMode: false,
                                accessibility: true,
                                responsive: [
                                    {
                                        breakpoint: 1024,
                                        settings: {
                                            slidesToShow: 4,
                                            slidesToScroll: 1,
                                            infinite: false,
                                            dots: false,
                                            arrows: true,
                                        }
                                    }
                                ]
                            });
                        }
                        else {
                            // Remove the slick slider for square-image carousels on tablet and mobile screen sizes
                            if ($(squareCarousel).hasClass('slick-initialized')) {
                                squareCarousel.slick("unslick");
                            }
                        }
                    }
				});
			}
		}
	},
	observeElementWidthWithIntersection: function (element, callback, options={}){
		if(!element || typeof callback !== 'function'){
			throw new Error('Element and callback must be provided');
		}
		const observer  = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if(entry.isIntersecting){
					const width = entry.boundingClientRect.width;
					callback(width);
				}
			})
		}, options)
		observer.observe(element);
		return () => observer.disconnect();
	},

	// magiczoom
	onExpandMagicZoomModal: function() {
		// focus on this element on close of modal
		const currentFocusedElement = document.activeElement;
		const magicZoomSelectors = document.querySelectorAll('.magic-thumbs-wrapper > ul > .magic-thumb');
		ACC.carousel.setTabIndexes(magicZoomSelectors);
		ACC.carousel.addEventListeners(magicZoomSelectors, (event) => ACC.carousel.switchToNewMagicZoomThumbnail(event, magicZoomSelectors));
		ACC.carousel.handleMagicZoomModalKeydown();
		ACC.carousel.closeMagicZoomModal(currentFocusedElement);
	},
	// magiczoom
	setTabIndexes: function(elements) {
		elements.forEach((el) => {
			el.setAttribute('tabindex', '0');
		});
	},
	// magiczoom
	addEventListeners: function(elements, eventListener) {
		elements.forEach((el) => {
			el.addEventListener('keydown', eventListener);
		});
	},
	// magiczoom
	handleMagicZoomModalKeydown: function() {
		const modal = document.querySelector('.mz-expand');
		if(modal) {
			let focusableElements = Array.from(modal.querySelectorAll(
				'[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled])'
			));

			// Handle mobile screens with JS as the configuration is different i.e Show Arrows is false on mobile
			const previousArrow = modal.querySelector('.mz-button-prev');
			const computedStyle = window.getComputedStyle(previousArrow);
			const displayValue = computedStyle.getPropertyValue('display');

			if (previousArrow && displayValue === 'none') {
				const buttonsToRemove = ['mz-button-prev', 'mz-button-next'];
				const filteredFocusableElements = focusableElements.filter(element => {
					const containsButtonToRemove = buttonsToRemove.some(buttonClass =>
						element.classList.contains(buttonClass)
					);
					return !containsButtonToRemove;
				});
				focusableElements = [...filteredFocusableElements]
			}
			const firstFocusableElement = focusableElements[0];
			const lastFocusableElement = focusableElements[focusableElements.length - 1];

			firstFocusableElement.focus();

			modal.addEventListener('keydown', function(event) {
				if (event.code === 'Tab') {
					if (event.shiftKey) {
						if (
							document.activeElement === modal ||
							document.activeElement === firstFocusableElement
						) {
							lastFocusableElement.focus();
							event.preventDefault();
						}
					} else {
						// Tab key pressed
						if (document.activeElement === lastFocusableElement) {
							firstFocusableElement.focus();
							event.preventDefault();
						}
					}
				}
			})
		}
	},
	// magiczoom
	switchToNewMagicZoomThumbnail: function (event, mZoomSelectors) {
		if (ACC.carousel.magicZoomKeydown(event)) {
			mZoomSelectors.forEach((el) => {
				if (el.classList.contains('magic-thumb-selected')) {
					el.setAttribute("class", "magic-thumb");
				};
			});
			document.activeElement.setAttribute("class", "magic-thumb magic-thumb-selected");

			let index = 0;
			mZoomSelectors.forEach((el) => {
				index++
				if (el.classList.contains('magic-thumb-selected')) {
					const viewNumber = index -1;
					MagicZoom.switchTo('zoom', viewNumber)
				};
			});
		}
	},
	// magiczoom
	closeMagicZoomModal: function(focusableElement) {
		const modal = document.querySelector('.mz-expand');
		if(modal) {
			const mzExpand = modal.querySelector('.mz-button-close');
			mzExpand.addEventListener('keydown', (event) => {
				if (ACC.carousel.magicZoomKeydown(event)) {
					MagicZoom.close('zoom');
					focusableElement.focus();
				}
			});
		}
	},
	// magiczoom
	// setting alt tag to null to prevent NVDA repeated information
	setMagicZoomLensAltLabel: function() {
		const magicZoomAnchor = document.getElementById('zoom');

		if (!magicZoomAnchor) {
			return;
		}

		const mzlens = magicZoomAnchor.querySelector('.mz-lens');

		if(!mzlens) {
			return;
		}

		const mzlensImage = mzlens.querySelector('img');

		if(mzlensImage) {
			mzlensImage.setAttribute('alt', '');
		}
	},
	// magiczoom
	magicZoomKeydown: function(event) {
		var key = event.which;
		// Space and Enter keys
		if (key === 13 || key === 32) {
			event.preventDefault();
			return true;
		}
		return false;
	},

	// magiczoom
	// to show which image is selected we will create a screenreader only div in the html
	setScreenReaderMessageForMagicZoom() {
		const id = document.getElementById('pdp-selected-image-callout');
		if(!id) {
			return;
		}
		const paragraph = id.getElementsByTagName('p')[0];
		if(!paragraph) {
			return;
		}
		const altMessage = ACC.carousel.getScreenReaderMessageForMagicZoom();
		if(altMessage) {
			paragraph.textContent = altMessage;
		}
	},
	getScreenReaderMessageForMagicZoom() {
		const mzSelector = document.getElementById('magicZoomSelectors')
		if(!mzSelector) {
			return;
		}
		const selected = mzSelector.getElementsByClassName('mz-thumb-selected')[0];

		if(!selected) {
			return;
		}
		const img = selected.getElementsByTagName('img')[0];
		return img.alt || '';
	},
	//Gtm product carousel data push
	gtmProductCarouselClicked : function(el) {
		var magicZoomSelectors = $('#magicZoomSelectors .mz-thumb');
		var mzSelectorsLength = magicZoomSelectors.length;
		var index = el.index() + 1;
		var productCode = $('#magicZoomSelectors .mz-thumb').data('productcode');

		if ( mzSelectorsLength > 0) {
			var viewNumber = index + "/" + mzSelectorsLength;
			ACC.gtm.trackProductGalleryImagesClickGtmEvent('' + productCode + '', '' + viewNumber + '');
		}

	},

	//Gtm content carousel data push
	gtmContentCarouselClicked: function($component) {
		var $container = $component.parents(".slick-slider").find(".slick-active .img-imgtitle");
		if($container.length > 0){
		     var componentid = $container.data("componentid");
		     var status = $container.data("status");
		     if($container.length > 0 && componentid.length > 0 && status > 0){
		    	 ACC.gtm.trackCarouselNonProductClickGtmEvent(componentid, status);
		     }
		}
	},

	gtmContentCarouselCTAClicked: function($component) {
		var $container = $component.parents(".slick-slider").find(".slick-active .img-imgtitle");
		if($container.length > 0){
		     var componentId = $container.data("componentid");
		     var status = $container.data("status");
		     if($container.length > 0 && componentId.length > 0 && status > 0){
		    	 ACC.gtm.trackPromotionClickGtmEvent(componentId, status);
		     }
		}
	},

	setupProductCarousel: function(id) {
		// Product
		var target = id ? ('#solrCarousel-' + id + ' ') : '';

		$(target + '.product-multi-4').slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 4,
			accessibility: false,
			responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: true,
					dots: true,
					arrows: false
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true,
					arrows: false
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					dots: true,
					arrows: false
				}
			},
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: false
				}
			}
			]
		});
		$(".product-multi-4 .slick-track").each(function(index, elm) {
			$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.gtmPrdCarouselClick, div[aria-hidden="true"] a.love-button, div[aria-hidden="true"] .c-product-card__quick-buy a')).attr('tabindex', -1);
			$($(elm).find('div[aria-hidden="false"] a.gtmPrdCarouselClick, div[aria-hidden="false"] a.love-button, div[aria-hidden="false"] .c-product-card__quick-buy a')).attr('tabindex', 0);
		});
		$('.product-multi-4 .slick-arrow, .product-multi-4 .slick-dots li').click(function(){
			$(".product-multi-4 .slick-track").each(function(index, elm) {
				$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.gtmPrdCarouselClick, div[aria-hidden="true"] a.love-button, div[aria-hidden="true"] .c-product-card__quick-buy a')).attr('tabindex', -1);
				$($(elm).find('div[aria-hidden="false"] a.gtmPrdCarouselClick, div[aria-hidden="false"] a.love-button, div[aria-hidden="false"] .c-product-card__quick-buy a')).attr('tabindex', 0);
			});
		});
		$(".product-multi-4").css('visibility','visible');
		$(document).on('click', '.lovelist-tooltip .close', function () {
			$(this).closest('.love-button').removeClass('add-tooltip');
		});
		ACC.carousel.checkLoveListIcon()
		$(window).scroll(function() {
			var scrollPosition = $(window).scrollTop();
			if (scrollPosition >= 0) {
				$('.love-button').removeClass('add-tooltip');
				$('.pdp-add-lovelist-button').removeClass('add-tooltip');
			}
		});
		ACC.common.loveAnimation();
	},
	checkLoveListIcon: function() {
		$('.js-update-lovelist').each(function () {
			var productCode = $(this).data('ll-product-code');
			var bundleId = $(this).data('ll-bundle-id');
			var checkProductLoveState = ACC.gtm.checkProductInLoveList(productCode.toString(),bundleId.toString());

			if (checkProductLoveState) {
				$('.icon-'+productCode).removeClass('icon-heart-empty').addClass('icon-heart');
			}
		});
	},
	loveListStaticButton: function () {
		const isGuest = window.ACC.gtm.isEmpty(window.ACC.gtm.getCookiebyName(window.ACC.lovelistCookieKey));
		const isMobileApp = typeof TKMaxxWebView !== 'undefined';

		$(document).on('click', '.js-update-lovelist', function(e) {
			const productCode = $(this).data('ll-product-code');
			const bundleIds = $(this).data('ll-bundle-id');
			const pageType = $(this).attr('data-page-type');

			// Determine the current state of the heart icon
			const checkState = e.target.querySelector('i')
            ? e.target.querySelector('i').classList.contains('icon-heart')
            : e.target.classList.contains('icon-heart');

			const action = checkState === true ? 'remove' : 'add';
        	const eventType = action === 'add' ? 'AddToLoveList' : 'RemoveFromLoveList';
			// Message object
			const messageContent = {
				eventType,
				details: productCode.toString()
			};

			if (isMobileApp) {
				// sending message to flutter api
				TKMaxxWebView.postMessage(`${JSON.stringify(messageContent)}`);

				// exit without modifying the love list
				if (isGuest) {
					return;
				}

			}

			if (checkState) {
				ACC.ll.updateLoveListEvent(productCode.toString(), bundleIds, 'remove', event, pageType);
				$('.icon-'+productCode).removeClass('icon-heart').addClass('icon-heart-empty').removeClass('pulse-animate');
				window.ACC.gtm.trackRemoveFromLoveList(productCode.toString(),pageType);
			} else {
				ACC.ll.updateLoveListEvent(productCode.toString(), bundleIds, 'add', event, pageType).then(function(response){
					if(response === true){
						$('.icon-'+productCode).removeClass('icon-heart-empty').addClass('icon-heart').addClass('pulse-animate');
					}
					window.ACC.gtm.trackAddToLoveList(productCode.toString(),pageType);
				});
			}
		});
	},

	// new method for calling Product Recommendation carousels, any previous carousel init methods will
	// need removing as part of a longer term migration plan to Vue JS
	initProductCarousel: function(carouselId) {
        var target = carouselId ? '#' + carouselId + ':not(.slick-initialized)' : '';
		const initializedTarget = carouselId ? `#${carouselId}` : '';
		const isCarouselForModal = $(target).closest('.product-recommendation-container-for-modal')?.length ? true : false;
		const pageType = window.ACC.gtm.pageType;
		const productItems = document.querySelectorAll('.c-product-grid .c-product-grid__item').length;
		const isWideContainer = (pageType === 'Search' && productItems === 0) || pageType === 'HomePage'  || pageType === 'ProductPage' || pageType === 'CategoryPage' || pageType === 'CartPage' || (window.ACC.carousel.isShyBrandPage() && pageType === 'ContentPage');
		switch (carouselId) {
                case 'FREQUENTLY_BOUGHT_TOGETHER':
                    $(target).slick({
                        dots: true,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        accessibility: false,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 320,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            }
                        ]
                    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
						$('.love-button').removeClass('add-tooltip');
					});
                    break;

            case 'YOU_MAY_ALSO_LOVE':
                $(target).slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    accessibility: false,
                    responsive: [
                        {
                            breakpoint: 1025,
                            settings: {
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 320,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: false
                            }
                        }
                    ]
                }).on('afterChange', function(event, slick, currentSlide, nextSlide){
					$('.love-button').removeClass('add-tooltip');
				});
                break;
            default:
                if (carouselId.endsWith('SLIMMED_CAROUSEL')) {
                    $(target).slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 7,
                        slidesToScroll: 1,
                        accessibility: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 5.5,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 820,
                                settings: {
                                    slidesToShow: 5.5,
                                    arrows: false,
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 5.5,
                                    arrows: false,
                                    variableWidth: true,
                                }
                            },
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 4.5,
                                    infinite: false,
                                    arrows: false,
                                    variableWidth: true,
                                }
                            },
							{
								breakpoint: 480,
								settings: {
									slidesToShow: 3.5,
									arrows: false,
									variableWidth: true,
								}
							},
							{
                                breakpoint: 320,
                                settings: {
                                    slidesToShow: 2.7,
                                    arrows: false,
									variableWidth: true,
                                }
                            }
                        ]
                    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
                        $('.love-button').removeClass('add-tooltip');
                    });
                    break;
                } else {
					if(isCarouselForModal) {
						$(target).slick(ACC.carousel.getModalCarouselConfig()).on('beforeChange', function(event, slick, currentSlide, nextSlide){
						// Disable clicks on links during drag
						$(target + ' a').css('pointer-events', 'none');
					})
					.on('afterChange', function(event, slick, currentSlide, nextSlide){
						$(target + ' a').css('pointer-events', 'none');
						const $track = $(this).find('.slick-track');
						$track.find('.slick-slide').attr('tabindex', -1);
						$track.find('.slick-slide[aria-hidden="false"]').attr('tabindex', 0);
                    });
					$(initializedTarget).each(function() {
						const slider = $(this)[0];
						let blockNextClick = false;

						// Slick swipe event (jQuery)
						$(slider).on('swipe', function() {
							blockNextClick = true;
							setTimeout(() => { blockNextClick = false; }, 400);
						});

						// Native click event in capture phase
						slider.addEventListener('click', function(e) {
							if (blockNextClick) {
								e.target.blur();
								e.preventDefault();
								e.stopImmediatePropagation();
								blockNextClick = false;
								return false;
							}
						}, true);
					});

					} else {
						const additionalBreakpointsForWiderContainer = 	isWideContainer ? [
						{
							breakpoint: 1280,
							settings: {
								slidesToShow: 5,
								arrows: false,
							}
						},
						{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4.5,
							arrows: false,
							}
						}
					] : [{}];
                    $(target).slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: isWideContainer ? 5 : 4,
                        slidesToScroll: 1,
                        accessibility: true,
                        responsive: [
							...additionalBreakpointsForWiderContainer,
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 4,
									arrows: false,
                                }
                            },
                            {
                                breakpoint: 930,
                                settings: {
                                    slidesToShow: 3.5,
                                    arrows: false,
                                }
                            },
                            {
                                breakpoint: 820,
                                settings: {
                                    slidesToShow: 3,
                                    arrows: false,
                                    variableWidth: true,
                                }
                            },
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 2,
                                    arrows: false,
                                    variableWidth: true,
                                }
                            },
                            {
                                breakpoint: 400,
                                settings: {
                                    slidesToShow:  1.7,
									arrows: false
                                }
                            }
                        ]
                    })
					.on('afterChange', function(event, slick, currentSlide, nextSlide){
                        $('.love-button').removeClass('add-tooltip');
                    });
                    break;
                }
				}
		}
		$(".product-carousel__stage .slick-track").each(function(index, elm) {
			$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.c-product-card, div[aria-hidden="true"] a.love-button, div[aria-hidden="true"] .c-product-card__quick-buy a')).attr('tabindex', -1);
			$($(elm).find('div[aria-hidden="false"] a.c-product-card, div[aria-hidden="false"] a.love-button, div[aria-hidden="false"] .c-product-card__quick-buy a')).attr('tabindex', 0);
		});
		$('.product-carousel__stage .slick-arrow, .product-carousel__stage .slick-dots li').click(function(){
			$(".product-carousel__stage .slick-track").each(function(index, elm) {
				$($(elm).find('div[aria-hidden="true"], div[aria-hidden="true"] a.c-product-card, div[aria-hidden="true"] a.love-button, div[aria-hidden="true"] .c-product-card__quick-buy a')).attr('tabindex', -1);
				$($(elm).find('div[aria-hidden="false"] a.c-product-card, div[aria-hidden="false"] a.love-button, div[aria-hidden="false"] .c-product-card__quick-buy a')).attr('tabindex', 0);
			});
		});
	},
	cleanUpSlickArtifacts: function($carousel) {
		// Remove leftover arrows and slick-list if any remain after unslick
		$carousel.find('.slick-arrow, .slick-list, .slick-track').remove();
		$carousel.removeClass('slick-initialized slick-slider');
	},
	isModalVisible: function() {
    	return $('.add-to-bag-dialog:visible')?.length > 0;
	},
	fixAllModalCarouselsOnOrientation: function(resetPosition=false) {
		if(ACC.carousel.isModalVisible()) {
			$('.product-recommendation-container-for-modal .product-carousel__stage').each(function() {
				const slider = $(this);
				const $track = slider.find('.slick-track');
				const isBroken = $track.css('opacity') == '0' || $track.width() == 0;
				if(resetPosition && !isBroken) {
					slider.slick('setPosition');
				}
				if (slider.hasClass('slick-initialized') && !isBroken) {
					if (slider && typeof slider.slick === 'function') {
						const slickObj = slider.slick('getSlick');
						if (slickObj) {
							const maxFirstSlide = Math.max(
								0,
								(slickObj.slideCount ?? 0) - (slickObj.options?.slidesToShow ?? 0)
							);
							if (slickObj.currentSlide > maxFirstSlide) {
								slider.slick('slickGoTo', maxFirstSlide, true);
							}
							slider.slick('setPosition');
						}
					}
				} else {
					// If broken or not initialized, destroy and re-init
					if (slider.hasClass('slick-initialized')) {
						slider.slick('unslick');
						ACC.carousel.cleanUpSlickArtifacts(slider);
					}
					if (!slider.hasClass('slick-initialized')) {
						slider.slick(ACC.carousel.getModalCarouselConfig());
					}
				}
			});
		}
	},

    /**
     * @description this method is used to re-render the carousel components
     * after the user has applied changes on them, using the Smart Edit plugin
     *
     * hybris-custom/custom/tjxstorefront/web/webroot/_ui/addons/smarteditaddon/
     * shared/common/js/adjustComponentRenderingToSE.js
     */
    smartEditRefreshCarouselComponents: function() {

        var vueCarouselComponents = Array.from($('.js-product-carousel[data-app]'));

        var carouselIds = Array.from($('[carousel-id]')).map(function(el) {
            return el.attributes['carousel-id'].value;
        });

        // Update Homepage carousel
        if ($('.js-homepage-hero-carousel').length) {
            ACC.carousel.bindCarousel();
            $(".flick-fix").show();
        }

		if($('.category-carousel-main').length) {
			ACC.carousel.setupCategoryCarousel();
		}

        /** Update PLP jsp carousel component
         * .../cms/tjxsolrqueryproductcarouselcomponent.jsp
         */
        $('.product-carousel-wrapper').each(function() {
            if ($(this).is(':empty')) {
                $(this).html('<input type="hidden" class="hidden" />');
                var solrCarouselId = $(this).data("solrCarouselId");
                ACC.common.ajaxSolrCarousel(solrCarouselId);
            }
        });


        /**Update PLP vue carousel components
         * e.g: <product-recommendation/> or <recently-viewed/>
         */
        vueCarouselComponents.forEach(function(comp, index) {
            if ($('[carousel-id="' + carouselIds[index] + '"]').length && $.trim($(comp).children().html()) === '') {
                window.reloadVueComponent(comp);
                ACC.carousel.initProductCarousel(carouselIds[index]);
            }
        });
    },

	updateLoveListFromStatic: function (product, event, elementThis) {
        var checkState;
        var element = elementThis;
        var pageType = element.getAttribute('data-page-type');
        if (event.target.querySelector('i')) {
            checkState = event.target.querySelector('i').classList.contains('icon-heart');
        } else {
            checkState = event.target.classList.contains('icon-heart');
        }
        if (checkState) {
            ACC.ll.updateLoveListEvent(product.toString(), 'remove', event, pageType);
            $('.icon-'+product.toString()).removeClass('icon-heart').addClass('icon-heart-empty').removeClass('pulse-animate');
            ACC.gtm.trackRemoveFromLoveList(product, pageType);
        } else {
			ACC.ll.updateLoveListEvent(product.toString(), 'add', event, pageType);
			if (!window.ACC.ll.checkLoveListSize()) {
				$('.icon-'+product.toString()).removeClass('icon-heart-empty').addClass('icon-heart').addClass('pulse-animate');
            	ACC.gtm.trackAddToLoveList(product, pageType);
			}
		}
		ACC.common.enableHeaderLoveListIcon();
	},
	getModalCarouselConfig: function(slidesToShow = 4.7) {
		return {
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			accessibility: true,
			variableWidth: false,
			touchThreshold: 1000,
			swipeToSlide: true,
			draggable: true,
			arrows: true,
			responsive: [
							{ breakpoint: 1440, settings: { slidesToShow: 4.7 } },
							{ breakpoint: 960,  settings: { slidesToShow: 4.7 } },
							// --- 420px to 639px Range Fix ---
							{ breakpoint: 640,  settings: { slidesToShow: 4.1 } }, // Desktop/Tablet transition
							{ breakpoint: 639,  settings: { slidesToShow: 6.2 } }, // Mobile starts here
							{ breakpoint: 580,  settings: { slidesToShow: 5.7 } }, 
							{ breakpoint: 500,  settings: { slidesToShow: 5.2 } }, 
							{ breakpoint: 460,  settings: { slidesToShow: 4.9 } }, // Added to prevent stretching 
							// --- Small Mobile Range ---
							{ breakpoint: 420,  settings: { slidesToShow: 4.1 } }, 
							{ breakpoint: 390,  settings: { slidesToShow: 4.1 } }
						]
		};
	},
};
// trigger setupCategoryCarousel after the whole page is loaded to avoid issues on SRP
// category carousel not being loaded properly
$(window).on('load', function() {
	window.ACC.carousel.setupCategoryCarousel();
    window.ACC.carousel.setupCtalinksCarousel();
});

(function($) {

	function debounce(fn, delay) {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    $(function() {
        const $containerSelector = '.product-recommendation-container-for-modal';
        const $carouselSelector = '.product-recommendation-container-for-modal .product-carousel__stage';

        // Detect monitor baseline (Standard 1.0 vs Retina 2.0)
        const isRetina = window.matchMedia('(min-resolution: 2dppx), (-webkit-min-device-pixel-ratio: 1.5)').matches;
        const nativeDPR = isRetina ? 2.0 : 1.0;

        function applyZoomRules() {
            const $container = $($containerSelector);
            const $carousel = $($carouselSelector);

            if (!$container.length) return;

            // --- 1. THE MOBILE/TABLET GUARD ---
            // Checks for touch capability and pointer precision.
            // Responsive Mode in DevTools emulates touch, so this will return false.
            const isDesktop = window.matchMedia('(pointer: fine)').matches;
			const isTouchPrimary = window.matchMedia('(pointer: coarse)').matches;

            // If it's a mobile/tablet device (real or emulated), always show and exit.
			
            // --- 2. THE ZOOM CALCULATION ---
            // Chrome/Edge: dprZoom tracks browser zoom (Ctrl +/-).
            const currentDPR = window.devicePixelRatio || 1;
            const dprZoom = currentDPR / nativeDPR;
            
            // Safari Fix: Compare physical screen width to viewport.
            // On a 1440px Mac at 200% zoom, innerWidth becomes 720px (1440/720 = 2.0).
            const screenZoom = window.screen.width / window.innerWidth;
			
            // Trigger if either detects >= 200% zoom (using 1.9 for safety).
            const isZoomed200 = (dprZoom >= 2) || (screenZoom >= 2);

            if (isTouchPrimary) {
				$container.removeAttr('style');
				setTimeout(() => {
					ACC.carousel.fixAllModalCarouselsOnOrientation(true);
				}, 300);
				return;
			}
			if (isDesktop && !isZoomed200) {
				$container.removeAttr('style');
				setTimeout(() => {
					ACC.carousel.fixAllModalCarouselsOnOrientation(true);
				}, 300);
				return;
			}
			if (isZoomed200) {
				$container.attr('style', 'display: none');
			} else {
				$container.removeAttr('style');
				if ($carousel.hasClass('slick-initialized')) {
					setTimeout(() => {
						ACC.carousel.fixAllModalCarouselsOnOrientation(true);
					}, 300);
				}
			}
        }
		const debouncedApplyZoomRules = debounce(applyZoomRules, 150);

        // --- Event Listeners ---
        $(window).on('resize', function() {
            window.requestAnimationFrame(debouncedApplyZoomRules);
        });

        // Handles "Zoom first, then open modal"
        const observer = new MutationObserver(function() {
            if ($($containerSelector).length) debouncedApplyZoomRules();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        debouncedApplyZoomRules();
    });
})(jQuery);
